import SearchInput from '@features/search/ui/input'

export default function SearchModal () {
  return (
    <SearchInput
      openModalAfterFocus={false}
      showResults
      inModal
      focusAfterMount
    />
  )
}
